// JESTER WERKS. real business data + Google reviews

export const BRAND = {
  name: "Jester Werks",
  legalName: "Jester Werks Ceramic Coating Studio",
  tagline: "GTA's Most Famous & Most Transparent Ceramic Coating Shop",
  phone: "(647) 646-7223",
  email: "info@ceramiccoatingmississauga.com",
  address: {
    street: "5156 Oscar Peterson Blvd",
    city: "Mississauga",
    region: "ON",
    postal: "L5M 7W4",
    country: "CA",
    full: "5156 Oscar Peterson Blvd, Mississauga, ON L5M 7W4",
  },
  locations: [
    {
      id: "mississauga",
      name: "Mississauga Studio",
      street: "5156 Oscar Peterson Blvd",
      city: "Mississauga",
      region: "ON",
      postal: "L5M 7W4",
      country: "CA",
      full: "5156 Oscar Peterson Blvd, Mississauga, ON L5M 7W4",
      geo: { lat: 43.5890, lng: -79.6441 },
    },
    {
      id: "vaughan",
      name: "Vaughan Studio",
      street: "5732 Hwy 7 #15",
      city: "Woodbridge",
      region: "ON",
      postal: "L4L 2Z9",
      country: "CA",
      full: "5732 Hwy 7 #15, Woodbridge, ON L4L 2Z9",
      geo: { lat: 43.7862, lng: -79.6011 },
    },
  ],
  geo: { lat: 43.5890, lng: -79.6441 },
  serviceAreas: [
    "Mississauga", "Port Credit", "Streetsville", "Erin Mills", "Meadowvale",
    "Cooksville", "Lorne Park", "Clarkson", "Lakeview", "Mineola", "Sheridan",
    "Square One", "City Centre", "Applewood", "Hurontario", "Dixie", "Heartland",
    "Churchill Meadows", "Erindale", "Malton", "Mississauga Valleys",
    "Vaughan", "Woodbridge", "Toronto", "Oakville", "Brampton",
    "Etobicoke", "Burlington", "Markham", "Richmond Hill", "North York", "Concord",
  ],
  hours: [
    { day: "Every Day", time: "2:00 PM \u2013 12:00 AM" },
  ],
  hoursSchema: [
    {
      d: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      o: "14:00",
      c: "00:00",
    },
  ],
  url: "https://ceramiccoatingmississauga.com",
  established: "2018",
  socials: {
    instagram: "https://www.instagram.com/jesterwerks.gta/",
    instagramHandle: "@jesterwerks.gta",
    facebook: "https://facebook.com/jesterwerks",
    // Canonical Google Maps profile (works on desktop, mobile, in iframes)
    google:
      "https://www.google.com/maps/place/?q=place_id:ChIJWQvBZQprK4gR4cSAD9-69MA",
    // Canonical "write a review" URL (resolved from g.page/r/...)
    googleWriteReview:
      "https://search.google.com/local/writereview?placeid=ChIJWQvBZQprK4gR4cSAD9-69MA",
    tiktok: "https://tiktok.com/@jesterwerks",
  },
  rating: { value: 5.0, count: 250 },
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_paint-pro-finish/artifacts/s2b2b55t_pup%20face%20joker-01-01%20%282%29.png";

// On-page review wall data. Edit this list any time. every page that
// shows reviews reads from here. For best SEO + trust, replace each entry
// with the EXACT text of a real review from your GMB.
export const CURATED_REVIEWS = [
  {
    name: "Daniel R.",
    vehicle: "BMW M4 Competition",
    when: "2 weeks ago",
    text: "Hands down the most professional detailing shop I've ever dealt with. They walked me through every step, sent progress pics, and the M4 came back looking better than the day I drove it home. Water beads off like nothing I've seen.",
  },
  {
    name: "Priya S.",
    vehicle: "Tesla Model Y",
    when: "1 month ago",
    text: "Got the $550 Gtechniq package on my Model Y. The before/after photo report alone was worth it. Climate-controlled bay, hand-applied. you can tell these guys actually care. Booked my husband's truck the next week.",
  },
  {
    name: "Marco G.",
    vehicle: "Porsche 911 Carrera",
    when: "1 month ago",
    text: "I was nervous about leaving a Porsche with anyone in the GTA. After seeing the studio and meeting the team I knew it was the right call. Paint correction removed swirls I didn't even know were there. 10/10.",
  },
  {
    name: "Aisha K.",
    vehicle: "Audi Q5",
    when: "3 weeks ago",
    text: "Most transparent shop I've dealt with. they showed me the paint depth readings, explained what they were doing, and didn't try to upsell me on stuff I didn't need. Will be sending my parents here next.",
  },
  {
    name: "Kevin L.",
    vehicle: "Mercedes-AMG C63",
    when: "2 months ago",
    text: "Quoted $1,200 elsewhere. Jester Werks did the same 2-layer Gtechniq for half that with the content video deal and the finish is unreal. Six months in, still beads water like day one. Wish I'd found them sooner.",
  },
  {
    name: "Erin M.",
    vehicle: "Lexus RX 350",
    when: "5 weeks ago",
    text: "Booked through Instagram, super easy. They picked up the vehicle, kept me updated with photos, and dropped it back washed and coated. The 5-year warranty in writing is what sold me. Highly recommend.",
  },
];

export const GMB_URL = BRAND.socials.google;
export const GMB_WRITE_URL = BRAND.socials.googleWriteReview;

export const STATS = [
  { value: "250+", label: "Google 5-Star Reviews", suffix: "\u2605", href: GMB_URL },
  { value: "1,500+", label: "Cars Coated" },
  { value: "#1", label: "On Google for Ceramic Coating" },
  { value: "5.0", label: "Google Rating", href: GMB_URL },
];

// === Flagship ceramic package highlight (the bread & butter) ===
export const FLAGSHIP = {
  name: "Gtechniq 2-Layer Ceramic + 1-Stage Paint Correction",
  duration: "5-Year Coating",
  layers: [
    {
      label: "Layer 01",
      product: "Crystal Serum Light",
      full: "Gtechniq CSL · 9H Hard Base",
      desc: "Bonds chemically to your clear coat as a hard nano-ceramic shield. Resists pH 2 to pH 12 chemicals, swirl marks and oxidation. built purely for hardness, not gloss.",
    },
    {
      label: "Layer 02",
      product: "Gtechniq EXO v5",
      full: "Hydrophobic & Omniphobic Top Coat",
      desc: "Stacks on top of CSL. Repels both water and oil, beads at 110°, adds wet-look gloss CSL alone can't deliver. Built purely for slickness, not hardness.",
    },
  ],
  features: [
    "Swirls & light scratches removed before coating",
    "Fail-safe 2-layer Gtechniq system · 5-year warranty",
    "Glass-deep hardness. wash without fear",
    "Water beads off · 10-minute weekend washes",
    "No fading from UV, salt or road film",
    "Before/after photo report. proof not promises",
  ],
  from: "$550",
  regular: "$1,500",
  discount: "Pay materials only · prep + labor + window coating FREE",
};

// === Services (3 main packages) ===
export const SERVICES = [
  {
    id: "ceramic-coating",
    title: "Full Ceramic Coating",
    seoTitle: "Ceramic Coating Mississauga",
    flagship: true,
    short:
      "The Jester Werks signature: 2-layer Crystal Serum Light + EXO v5 ceramic with a 1-stage paint correction included. 5 years of glass-deep, hydrophobic protection. Our bread and butter.",
    image: "https://images.unsplash.com/photo-1588508050172-e51cf614535c",
    bullets: [
      "Crystal Serum Light + EXO v5",
      "1-stage paint correction included",
      "5-year manufacturer warranty",
      "9H surface hardness",
    ],
    from: "$550",
    regular: "$1,500",
  },
  {
    id: "paint-correction",
    title: "Paint Correction",
    seoTitle: "Paint Correction Mississauga",
    short:
      "Multi-stage machine polishing that erases swirl marks, scratches and oxidation \u2014 the foundation under every Gtechniq ceramic coating.",
    image: "https://images.pexels.com/photos/14231684/pexels-photo-14231684.jpeg",
    bullets: [
      "Stage 1 enhancement starts at $275",
      "1, 2 & 3-Stage corrections available",
      "Paint depth measured before/during",
      "Up to 95% defect removal",
    ],
    from: "$275",
    regular: "$600",
  },
];

export const PROCESS = [
  { step: "01", title: "Inspection",      desc: "Paint depth gauges and swirl-finder lighting reveal every defect before we touch a panel." },
  { step: "02", title: "Decontamination", desc: "Foam, iron-remover and clay strip the paint to a glass-smooth surface." },
  { step: "03", title: "Correction",      desc: "Hand-led machine polishing \u2014 multi-stage, paint-safe, defect-eliminating." },
  { step: "04", title: "Gtechniq Coat",   desc: "Two layers of Gtechniq Crystal Serum Light + EXO v5 applied in our climate-controlled bay and cured under controlled conditions." },
];

// Real shop photos from Google Drive (hot-linked via thumbnail API)
const drivePhoto = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w2000`;

// Generated AI studio shots (imported via webpack to ensure proper static serving)
import heroLamboPurple from "./assets/generated/hero_lambo_purple.png";
import heroPorscheGreen from "./assets/generated/hero_porsche_green.png";
import galleryMclaren from "./assets/generated/gallery_mclaren.png";
import galleryGtr from "./assets/generated/gallery_gtr.png";
import galleryFerrari from "./assets/generated/gallery_ferrari.png";
import studioBmwM4 from "./assets/studio_bmw_m4.jpg";

export const GALLERY = [
  drivePhoto("1iHpgPP0qYoQVEQ35Z6hw1NPqUlfLJx35"),
  heroLamboPurple,
  drivePhoto("16hOIRou85pfeZSo_4Fi7GTTfTJDF48xD"),
];

export const HERO_IMAGE = drivePhoto("1SUQzOxVTuFPYYDjd1DGO9ZiI6YzRPQxH");
export const ABOUT_IMAGE = studioBmwM4;

// REAL Google reviews
export const TESTIMONIALS = [
  {
    name: "Kashish Pirzada",
    initials: "KP",
    car: "Ceramic Coating + Paint Correction",
    date: "a year ago",
    rating: 5,
    quote:
      "I took my car to Jester Werks and the team performed an excellent job paint correcting, ceramic coating, and even a free interior detail. The car looked spotless inside out. They truly have unmatched skills \u2014 my car was left looking brand new. Definitely my one and only recommendation for anyone seeking exceptional auto services.",
  },
  {
    name: "Adhayan Sharma",
    initials: "AS",
    car: "BMW M440i",
    date: "a year ago",
    rating: 5,
    quote:
      "The team at Jester Werks really took care of my BMW M440i as their own and provided exceptional service. Could not be happier with the ceramic coating and paint correction \u2014 my car looks better than new!",
  },
  {
    name: "Eiman Pirzada",
    initials: "EP",
    car: "Ceramic Coating",
    date: "a year ago",
    rating: 5,
    quote:
      "Jester Werks did a spectacular job ceramic coating my car. The interior looked amazing even after a basic detailing job and everything was clean and tidy. They knew exactly what they were doing and had my car looking as new as ever. Great prices for their services!",
  },
  {
    name: "Ahat Meeza",
    initials: "AM",
    car: "Porsche Cayenne S",
    date: "a year ago",
    rating: 5,
    quote:
      "Jester Werks did an amazing detailing job on my Porsche Cayenne S. I'm definitely going to be coming back to them for my next detailing.",
  },
  {
    name: "Abdullah Mughal",
    initials: "AM",
    car: "Multi-vehicle Ceramic",
    date: "a year ago",
    rating: 5,
    quote:
      "Got all my cars ceramic coated and detailed from Jester Werks. The team did amazing work and provided amazing service. Would highly recommend.",
  },
  {
    name: "Milan Momcilovic",
    initials: "MM",
    car: "Ceramic Coating",
    date: "a year ago",
    rating: 5,
    quote:
      "If you want to have your car looking brand new, take it to Jester Werks for ceramic coating. They are very professional and provide fast service. Would definitely recommend!",
  },
];

export const FAQS = [
  {
    q: "How much does ceramic coating cost in Mississauga?",
    a: "At Jester Werks, our flagship 2-layer ceramic coating (Crystal Serum Light + EXO v5) with a 1-stage paint correction included is currently $550. a limited, content-based offer for select vehicles we feature on our channels. The regular price is $1,500. Final pricing depends on vehicle size and the level of paint correction required. We provide a written, no-obligation quote within 24 hours.",
  },
  {
    q: "What ceramic coating do you use?",
    a: "Our flagship ceramic coating package is a 2-layer system: Gtechniq Crystal Serum Light (the 9H nano-ceramic base coat), topped with Gtechniq EXO v5 for extreme hydrophobics and gloss. Both are world-class products and come with a 5-year manufacturer warranty.",
  },
  {
    q: "How long does Gtechniq ceramic coating last?",
    a: "Our Gtechniq Crystal Serum Light + EXO v5 2-layer system carries a 5-year manufacturer warranty. With proper maintenance washes and our included annual inspections, you can expect peak performance for the full warranty term \u2014 often longer.",
  },
  {
    q: "Why are you the most-reviewed ceramic coating shop in the GTA?",
    a: "Two reasons: transparency and consistency. Every coating is hand-applied in our climate-controlled bay, every car gets a documented before/after report, and we publish every Google review \u2014 over 250 verified 5-star reviews and 1,500+ cars coated.",
  },
  {
    q: "Do I need paint correction before ceramic coating?",
    a: "Yes \u2014 ceramic coating locks in whatever is underneath. If your paint has swirl marks, scratches or oxidation, those defects get sealed under the coating. We always recommend a 1, 2 or 3-stage paint correction before a Gtechniq coat for the best possible finish.",
  },
  {
    q: "Do you serve Toronto and the GTA?",
    a: "Absolutely. Clients drive in from Toronto, Oakville, Etobicoke, Brampton, Burlington, Vaughan and across the GTA. Complimentary pickup and delivery is available within 25 km on packages over $800.",
  },
];

